import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=da83bb3c&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=da83bb3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da83bb3c",
  null
  
)

export default component.exports